<template>
  <div style="width: 100%">
    <div v-if="progress == 1" class="bg">
      <div style="width: 100%;text-align: center;margin-top:80px; font-size: 1em">
        <span v-if="type == 'read'" :style="{color: getColor(word), fontSize: '2.5em', margin: '0 40px 0 0'}">{{word.content1}}</span>
        <span v-if="type == 'read'" :style="{color: getColor(word), fontSize: '1.3em', margin: '0 40px 0 0'}">{{word.content2}}</span>
        <i v-if="type == 'read'" :style="{color: getColor(word), fontSize: '1.4em'}" @click="playAudio(word.content7)" class="el-icon-video-play"></i>
        <i v-if="type == 'listen'" :style="{color: getColor(word), fontSize: '3em'}" @click="playAudio(word.content7)" class="el-icon-video-play"></i>
        <i v-if="type == 'write'" :style="{color: getColor(word), fontSize: '4em',margin: '40px 0'}" @click="playAudio(word.content7)" class="el-icon-video-play"></i>
      </div>
      <div v-if="type == 'read'" class="word" v-html="word.content8" :style="{width: '100%',textAlign: 'center',marginTop:'50px'}"></div>
    </div>
    <div v-else class="bg">
      <div class="word">
        【译】
        <span v-html="word.content3"></span>
      </div>
      <div class="word" v-html="word.content4"></div>
      <div class="word" v-html="word.content6"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['word','progress','type','learnProgress'],
  watch: {
    word: function(n) {
      this.playAudio(n.content7)
    }
  },
  methods: {
    playAudio(url) {
      let audio = new Audio()
      audio.src = `https://awesome-platform.oss-cn-shanghai.aliyuncs.com/quick/v${url}`
      audio.play();
    },
    contain(arr, item) {
      let flag = false;
      for (let i = 0; i < arr.length; i++) {
        if (item == arr[i]) {
          flag = true
        }
      }
      return flag
    },
    getColor(word) {
      if (this.contain(this.learnProgress.miss, word)) {
        return '#ac1a1a'
      } else if (this.contain(this.learnProgress.unsure, word)) {
        return '#ac681a'
      } else {
        return '#334970ee'
      }
    }
  }
}
</script>

<style scoped>
.bg{
  width: 85%;
  height: 400px;
  margin: 0 0 0 80px;
  border-radius: 30px;
  padding: 50px 60px 0;
  background-color: #fff;
  font-size: 1.5em;
  line-height: 40px;
  text-align: left;
  font-family: sans-serif;
  overflow: auto;
}
.word{
  margin: 20px 0;
}
@media screen and (max-width: 1400px){
  .bg{
    width: 75%;
    height: 280px;
    margin: 50px auto;
    border-radius: 30px;
    padding: 50px 60px 0;
    background-color: #fff;
    font-size: 1.1em;
    line-height: 40px;
    text-align: left;
    font-family: sans-serif;
    overflow: auto;
  }
  .word{
    margin: 20px 0;
  }
}
</style>
